<div class="display-flex-column font-small menu-wrapper">
    <div class="cursor-pointer flex-centered-container-vr gap-8-px">
        <app-display-picture [size]="50" routerLink="/trading/profile/"></app-display-picture>
        <div class="flex-centered-container-hr-column">
            <span class="font-16 full-width overflow-ellipsis">{{userNameDisplay}}</span>
            <span class="margin-4-vr fg-sb-text font-12">{{ isVendorLogin ? userName : userName + "'s uTrade Algos" }}</span>
            <div class="flex-centered-container-vr gap-8-px">
                <span class="font-10 fg-sb-text plan-name display-flex w-fit" *ngIf="!isAdmin">
                    <img [src]="crownIcon" class="crown-icon margin-4-right">
                    {{personalDetailsObj.plan}} Plan
                </span>
                <p class="no-margin fg-sb-text decoration-underline font-12 flex-centered-container-vr gap-4-px cursor-pointer"
                    *ngIf="plansEnabled && !isAdmin"  (click)="openBillingPortal(billingRoutes.Upgrade)"
                    [ngClass]="{'fg-sb-text': billingPortalLoading !== billingRoutes.Upgrade, 'no-data-text': billingPortalLoading === billingRoutes.Upgrade}">
                    <mat-spinner *ngIf="billingPortalLoading === billingRoutes.Upgrade" [diameter]="14" color="accent"></mat-spinner>
                    <span>{{ isSubscriptionCancelled ? 'Reactivate' : 'Upgrade' }}</span>
                </p>
            </div>
        </div>
    </div>

    <ng-container *ngIf="plansEnabled && !isAdmin && !isSubscriptionCancelled" >
        <div *ngIf="!walletBalanceLoading; else walletCardShimmer" class="profile-menu-credits">
            <div class="flex-centered-container gap-8-px mat-icon-16 margin-8-bottom">
                <div class="font-18 font-inter-semibold">{{ walletBalance?.available_credits | nullCheck: true }}</div>
                <span class="font-bold font-12">Credits</span>
                <span class="spacer"></span>
                <mat-icon class="material-icons-outlined cursor-pointer"
                    (click)="openBillingPortal(billingRoutes.TransactionHistory)"
                    matTooltip="Transaction History">info_outline</mat-icon>
            </div>
            <div class="profile-menu-credits-cards">
                <div class="credits-base-card">
                    <span class="font-inter-semibold">{{ walletBalance?.base_available | nullCheck: true }}</span>
                    <span>Base</span>
                </div>
                <div class="credits-topup-card" *ngIf="walletBalance?.topup_available > 0">
                    <span class="font-inter-semibold">{{ walletBalance?.topup_available | nullCheck: true }}</span>
                    <span>Topup</span>
                </div>
                <div class="credits-earned-card" *ngIf="walletBalance?.earned_available > 0">
                    <span class="font-inter-semibold">{{ walletBalance?.earned_available | nullCheck: true }}</span>
                    <span>Earned</span>
                </div>
            </div>
        </div>
    </ng-container>

    <div *ngIf="isVendorLogin" class="flex-space-around margin-8-top">
        <div>
            <div class="no-margin font-14 fg-sb-text flex-centered-container">{{ cumulativePnL | precision:DEFAULT_PRECISION | localeConverter:
                DEFAULT_PRECISION: true : true}}</div>
            <span class="no-margin font-12">Cumulative P/L</span>
        </div>
        <div>
            <div class="no-margin font-14 flex-centered-container" [ngClass]="{'text-green': totalProfit > 0, 'text-negative': totalProfit < 0}"> {{ totalProfit | precision:DEFAULT_PRECISION | localeConverter:
                DEFAULT_PRECISION: true : true}}</div>
            <span class="no-margin font-12">Booked P/L</span>
        </div>
    </div>

    <div class="display-flex-column margin-8 align-start">

        <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
            (click)="navigateToMyProfile()">
            <mat-icon class="margin-8-right material-icons-outlined" [svgIcon]="'my_profile'"></mat-icon>
            <span>My Profile</span>
        </button>

        <mat-divider class="position-relative"></mat-divider>

        <button mat-button disableRipple class='no-padding focus-out-btn outline full-width' (click)="connectBroker()" *ngIf="multiBrokerAllowed">
            <span class="flex-centered-container-vr flex-space-between">
                <span class="flex-centered-container-vr">
                    <mat-icon class="margin-8-right material-icons-outlined" [svgIcon]="'connect_broker'"></mat-icon>
                    <span>Manage Broker</span>
                </span>
                <!-- <div class="display-flex cue border-radius-16" *ngIf="showPlanExtendedOffer">
                        <img src="/assets/icons/red-gift.svg" alt="red-gift" class="red-gift margin-4-right">
                        <p>New Offer</p>
                    </div> -->
            </span>
        </button>

        <mat-divider class="position-relative"></mat-divider>

        <ng-container *ngIf="plansEnabled && !isAdmin && !isFreePlan">
            <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
                [disabled]="billingPortalLoading === billingRoutes.BillingDashboard"
                (click)="openBillingPortal(billingRoutes.BillingDashboard)">
                <div class="flex-centered-container-vr gap-8-px">
                    <mat-spinner *ngIf="billingPortalLoading === billingRoutes.BillingDashboard" [diameter]="16"></mat-spinner>
                    <mat-icon *ngIf="billingPortalLoading !== billingRoutes.BillingDashboard" class="material-icons-outlined">account_balance_wallet</mat-icon>
                    <span>Manage Subscriptions</span>
                </div>
            </button>
            <mat-divider class="position-relative"></mat-divider>
        </ng-container>

        <!-- <button mat-button disableRipple class='no-border no-padding focus-out-btn outline' routerLink="/">
            <mat-icon class="margin-8-right material-icons-outlined">home</mat-icon>
            <span>Dashboard</span>
        </button> -->

        <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
            (click)="navigateToGlobalExitSettings()">
            <mat-icon class="margin-8-right material-icons-outlined" [svgIcon]="'global_exit'"></mat-icon>
            <span>Global Exit Settings</span>
        </button>


        <!-- <mat-divider class="position-relative"></mat-divider>

        <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
            (click)="openPricingDialog()"
            *ngIf="!hidePlans && !authService.isSwastikaLogin && !isMasterTrustLogin && !authService.isPesbLogin">
            <mat-icon class="margin-8-right material-icons-outlined" [svgIcon]="'lightning'"></mat-icon>
            <span>Upgrade Plan</span>
        </button> -->

        <!-- <button mat-button disableRipple class='no-border no-padding focus-out-btn outline' (click)="openReports()"
            *ngIf="!isSwastikaLogin && !isMasterTrustLogin && !authService.isPesbLogin">
            <mat-icon class="margin-8-right material-icons-outlined" [svgIcon]="'report'"></mat-icon>
            <span>Reports</span>
        </button> --> 
        <mat-divider class="position-relative"
            *ngIf="!isSwastikaLogin && !isMasterTrustLogin && !authService.isPesbLogin"></mat-divider>

        <!-- <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
            routerLink="/trading/profile/funds" *ngIf="isVendorLogin">
            <mat-icon class="margin-8-right material-icons-outlined">credit_card</mat-icon>
            <span>Funds</span>
        </button> -->
        <ng-container *ngIf="helpConfig && helpConfig.isVisible">
        <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
            (click)="openNeedHelp()">
            <mat-icon class="margin-8-right material-icons-outlined" [svgIcon]="'need_help'"></mat-icon>
            <span> Need Help? </span>
        </button>
        <mat-divider class="position-relative"></mat-divider>
        </ng-container>

        <button mat-button disableRipple class='no-border no-padding focus-out-btn outline'
            *ngIf="isShareIndiaLogin && !isOperatorLogin" (click)="switchAccounts()">
            <mat-icon class="margin-8-right material-icons-outlined">swap_horiz</mat-icon>
            <span>Switch Accounts</span>
        </button>

        <button mat-stroked-button class='margin-8 panic-control' (click)="panicControl()">
            <span>PANIC CONTROL</span>
        </button>

        <button mat-button disableRipple class='no-border no-padding focus-out-btn outline' (click)="logout()">
            <mat-icon class="margin-8-right material-icons-outlined text-negative">logout</mat-icon>
            <span class="text-negative">Log Out</span>
        </button>
    </div>
</div>

<ng-template #walletCardShimmer>
    <app-wallet-card-shimmer></app-wallet-card-shimmer>
</ng-template>